module.exports = __webpack_public_path__ + "static/media/info-square.b93a0eab.svg";